// @ts-nocheck
import { OrderChangeRequestModel } from "@store/Framework/Types/ApiModels";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<Partial<OrderChangeRequestModel>>;

export const DispatchUpdateChangeRequestOrder: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/OrderChange/UpdateChangeRequestOrder",
        changeRequestOrder: props.parameter,
    });
};

export const chain = [DispatchUpdateChangeRequestOrder];

const updateChangeRequestOrder = createHandlerChainRunner(chain, "UpdateChangeRequestOrder");
export default updateChangeRequestOrder;
